var _title, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconBuilding = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "f85d4c23-7535-42b1-b09a-b0ae8e664449",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icoontjes_data")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M633.35,286.1V242.4H390.65V286h-76.9V781.6h149.3V633h99.1V781.6h148.1V286Zm-180,290.3h-79.3V477.3h79.3Zm0-119.7h0l-79.3.1V357.6h79.3ZM552,576.4h-79.3V477.3H552Zm0-119.7h0l-79.3.1V357.6H552Zm99.1,119.7h-79.3V477.3h79.3Zm0-119.7h0l-79.3.1V357.6h79.3Z"
})));
export default SvgIconBuilding;